import React, { useState } from "react";
import "./style.css";
// import Ribbon from "@tds/community-ribbon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faTimesCircle,
} from "@fortawesome/free-regular-svg-icons";
import { Image } from "react-bootstrap";
import { CustomLabel, typeOfCal } from "../../Constant";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { typeOfCalculator } from "../../Redux/InsurerReducer";

const BYP_Transiton_Card = ({ topSelling = false, data, onSubmenuChange }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id, subMenuClicked, type, image, label } = data;
  const SubMenu = (e, type) => {
    e.stopPropagation();
    onSubmenuChange();
  };
  const CardClick = (type) => {
    dispatch(typeOfCalculator(type));
    switch (type) {
      case typeOfCal.lifetime:
        navigate("/lifetime-health");
        break;
      case typeOfCal.prohealthPrime:
        navigate("/prohealth-prime");
        break;
      case typeOfCal.mchiSarvah:
        navigate("/sarvah");
        break;
      case typeOfCal.prohealth:
        navigate("/prohealth-insurance");
        break;
      case typeOfCal.superTopUp:
        navigate("/super-top-up");
        break;
      case typeOfCal.primeSenior:
        navigate("/prime-senior");
        break;
      case typeOfCal.ci:
        navigate("/critical-illness");
        break;
      case typeOfCal.pa:
        navigate("/personal-accident");
        break;
      case typeOfCal.accident_Shield:
        navigate("/accident-shield");
        break;

    }
  };
  return (
    <div className="row">
      <div className="col center">
        <div
          className="BYP_Card"
          id={type}
          onClick={(e) => CardClick(e.currentTarget.getAttribute("id"))}
        >
          <div className="row">
            <div className="col-6 text-start">
            
            </div>
            {/* <div className="col-6 text-end">
              <FontAwesomeIcon
                icon={faCircleCheck}
                style={{
                  color: "#cccccc",
                  marginRight: "10px",
                  height: "23px",
                  width: "23px",
                }}
              />
            </div> */}
          </div>
          <div className="row my-4 mx-2">
            <div className="col-12" style={{ textAlign: "-webkit-center" }}>
              <Image src={image} style={{ width: "60px", height: "60px" }} />
            </div>
            <div className="col-12 mt-3" style={{ textAlign: "center" }}>
              <CustomLabel font_size="18">{label}</CustomLabel>
            </div>
          </div>
          {/* <hr className="hr" />
          <div className="row my-3 mx-2" onClick={SubMenu}>
            <div className="col-8 text-start">
              <CustomLabel font_size="12" color="#1685ca">
                What does it cover?
              </CustomLabel>
            </div>
            <div className="col-4 text-end">
              <FontAwesomeIcon
                icon={subMenuClicked ? faAngleUp : faAngleDown}
                style={{ color: "#1685ca" }}
              />
            </div>
            {false && (
              <div className="col-12 my-2">
                <CustomLabel font_size="10" font_weight="normal">
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit.
                  Maecenas porttitor congue massa. Fusce posuere, magna sed
                  pulvinar ultricies, purus lectus malesuada libero, sit amet
                  commodo magna eros quis urna. Nunc viverra imperdiet enim.
                  Fusce est.
                </CustomLabel>
              </div>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default React.memo(BYP_Transiton_Card);
